<template>
  <Listbox as="div" v-model="selected" @update:modelValue="value => emit('update:modelValue', value)" class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2">
    <label :for="fieldPath" class="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{{ fieldLabel }}</label>
    <div class="relative w-full sm:max-w-xs">
      <ListboxButton
        class="grid h-8 w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
      >
        <span class="col-start-1 row-start-1 truncate pr-6">{{ selectedOption?.label ?? '' }}</span>
        <ChevronUpDownIcon class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4" aria-hidden="true" />
      </ListboxButton>
      <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <ListboxOptions
          class="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
        >
          <ListboxOption
            as="template"
            v-for="option in options"
            :key="option.id"
            :value="option.value"
            v-slot="{ active, selected }"
          >
            <li
              :class="[
                active ? 'bg-indigo-600 text-white outline-none' : 'text-gray-900',
                'relative cursor-default select-none py-2 pl-3 pr-9'
              ]"
            >
              <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">{{ option.label }}</span>
              <span
                v-if="selected"
                :class="[
                  active ? 'text-white' : 'text-indigo-600',
                  'absolute inset-y-0 right-0 flex items-center pr-4'
                ]"
              >
                <CheckIcon class="size-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
      <p v-if="errors && errors[fieldPath]" class="text-sm text-red-600">{{ errors[fieldPath] }}</p>
    </div>
  </Listbox>

</template>


<script setup>
import { ref, watch, computed } from "vue";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/vue";
import { ChevronUpDownIcon } from "@heroicons/vue/16/solid";
import { CheckIcon } from "@heroicons/vue/20/solid";

const props = defineProps(["modelValue", "fieldPath", "fieldAttrs", "fieldLabel", "errors", "options"]);
const emit = defineEmits(["update:modelValue"]);

const selected = ref(props.modelValue);

watch(() => props.modelValue, (newVal) => {
  selected.value = newVal;
});

const selectedOption = computed(() =>
  props.options.find(option => option.value === selected.value)
);
</script>
